module.exports = __webpack_public_path__ + "static/img/AI43W.b46e946.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI43W.jpg
// module id = ti+a
// module chunks = 2